var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-body" }, [
          _c(
            "div",
            { staticClass: "flex" },
            [
              _c("date-picker", {
                staticClass: "mr-2",
                attrs: {
                  type: "date",
                  range: "",
                  "value-type": "format",
                  format: "DD.MM.YYYY",
                  shortcuts: _vm.shortcuts,
                  placeholder: "Выберите дату",
                },
                on: { change: () => {} },
                model: {
                  value: _vm.filter.date,
                  callback: function ($$v) {
                    _vm.$set(_vm.filter, "date", $$v)
                  },
                  expression: "filter.date",
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "mr-2" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.filter.division,
                        expression: "filter.division",
                      },
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.filter,
                          "division",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "0", disabled: "" } }, [
                      _vm._v("Выберите дивизион"),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.$AllDivisions, function (div) {
                      return _c("option", { domProps: { value: div.id } }, [
                        _vm._v(_vm._s(div.title)),
                      ])
                    }),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex-grow-1 justify-content-end flex" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-info mr-1",
                      on: { click: _vm.tableToCSV },
                    },
                    [_vm._v("экспортировать с CSV")]
                  ),
                  _vm._v(" "),
                  _c("LoadingButton", {
                    attrs: {
                      title: "Поиск",
                      loading: _vm.loading,
                      color: _vm.$constants.PRIMARY_COLOR,
                      onClick: () => _vm.getRecords(),
                      className: "btn btn-outline-info",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("pulse-loader", {
        staticClass: "text-center",
        attrs: { loading: _vm.loading, color: _vm.$constants.LOADING_COLOR },
      }),
      _vm._v(" "),
      !_vm.loading && _vm.records?.length
        ? _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _c("table", { staticClass: "table table-sm table-hover mt-1" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.records, function (o, i) {
                    return _c("tr", { key: i }, [
                      _c("td", [_vm._v(_vm._s(i + 1))]),
                      _vm._v(" "),
                      _c("td", [
                        _c("p", [_vm._v(_vm._s(o.id))]),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(o.project_label))]),
                      ]),
                      _vm._v(" "),
                      _c("td", [_c("p", [_vm._v(_vm._s(o.address))])]),
                      _vm._v(" "),
                      _c(
                        "td",
                        _vm._l(o.details, function (d) {
                          return _c("p", [
                            _vm._v(
                              _vm._s(d.drug.title) +
                                " x " +
                                _vm._s(d.qty) +
                                " x " +
                                _vm._s(d.price)
                            ),
                          ])
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(_vm.printDate(o.report_date)))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(o.price))]),
                    ])
                  }),
                  0
                ),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("#")]),
        _vm._v(" "),
        _c("th", [_vm._v("ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("Адрес")]),
        _vm._v(" "),
        _c("th", [_vm._v("Препараты")]),
        _vm._v(" "),
        _c("th", [_vm._v("Дата")]),
        _vm._v(" "),
        _c("th", [_vm._v("Сумма")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }